"use strict";

var _react = _interopRequireDefault(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(a, b) {
  for (var c, d = 0; d < b.length; d++) {
    c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
}

function _createClass(a, b, c) {
  return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), a;
}

function _inherits(a, b) {
  if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(b && b.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), b && _setPrototypeOf(a, b);
}

function _setPrototypeOf(a, b) {
  return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
    return a.__proto__ = b, a;
  }, _setPrototypeOf(a, b);
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = _getPrototypeOf(a);

    if (b) {
      var e = _getPrototypeOf(this).constructor;

      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return _possibleConstructorReturn(this, c);
  };
}

function _possibleConstructorReturn(a, b) {
  return b && ("object" === _typeof(b) || "function" == typeof b) ? b : _assertThisInitialized(a);
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function _getPrototypeOf(a) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, _getPrototypeOf(a);
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var Confirmation = function (a) {
  function b() {
    var a;

    _classCallCheck(this, b);

    for (var d = arguments.length, e = Array(d), f = 0; f < d; f++) {
      e[f] = arguments[f];
    }

    return a = c.call.apply(c, [this].concat(e)), _defineProperty(_assertThisInitialized(a), "state", {
      confirmation: ""
    }), a;
  }

  _inherits(b, a);

  var c = _createSuper(b);

  return _createClass(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this.props.confirmation,
          b = /<script>(.+)<\/script>/gi.exec(a);
      b ? (a = a.replace(b[0], ""), this.setState({
        confirmation: a
      }, function () {
        return window.eval(b[1]);
      })) : this.setState({
        confirmation: a
      });
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.state.confirmation,
          b = this.props.SFormConfirmation;
      return b ? _react["default"].createElement(b, {
        success: !0,
        message: a
      }) : _react["default"].createElement("div", {
        className: "form-confirmation",
        dangerouslySetInnerHTML: {
          __html: a
        }
      });
    }
  }]), b;
}(_react["default"].Component),
    _default = Confirmation;

exports["default"] = _default;